import { render } from "./GlNotification.vue?vue&type=template&id=71922ff1&scoped=true"
import script from "./GlNotification.vue?vue&type=script&lang=js"
export * from "./GlNotification.vue?vue&type=script&lang=js"

import "./GlNotification.vue?vue&type=style&index=0&id=71922ff1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-71922ff1"

export default script